import React, { Component } from 'react';
import Button from '../button/Button';
import SelectTrigger from '../rc-components/select/SelectTrigger';
import { Item as MenuItem } from '../rc-components/menu';
import { UNSELECTABLE_ATTRIBUTE, UNSELECTABLE_STYLE } from '../rc-components/select/util';
import { getColumnKey } from './util';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
export default class ColumnFilter extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.onMenuSelect = (item) => {
            item.item.props.value.hidden = false;
            this.fireChange(item);
        };
        this.onMenuDeselect = (item) => {
            item.item.props.value.hidden = true;
            this.fireChange(item);
        };
        this.onDropdownVisibleChange = (open) => {
            const { state } = this;
            if (state.open !== open) {
                this.setState({
                    open,
                });
            }
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { prefixCls, getPopupContainer } = this.props;
        const { open } = this.state;
        const { getPrefixCls } = this.context;
        return (React.createElement("div", { className: `${prefixCls}-columns-chooser` },
            React.createElement(SelectTrigger, { prefixCls: getPrefixCls('select'), showAction: ['click'], options: this.getOptions(), value: this.getVisibleColumns(), getPopupContainer: getPopupContainer, multiple: true, onDropdownVisibleChange: this.onDropdownVisibleChange, onMenuSelect: this.onMenuSelect, onMenuDeselect: this.onMenuDeselect, visible: open, popupPlacement: "bottomRight", dropdownMatchSelectWidth: false, dropdownStyle: { minWidth: 187 } },
                React.createElement(Button, { shape: "circle", icon: "view_column", size: Size.small }))));
    }
    fireChange(item) {
        const { onColumnFilterChange } = this.props;
        if (onColumnFilterChange) {
            onColumnFilterChange(item);
        }
    }
    getOptions() {
        const { columns } = this.props;
        const options = [];
        (columns || []).forEach((column, i) => {
            const { title, notDisplay, disableClick } = column;
            if (title && !notDisplay) {
                options.push(React.createElement(MenuItem, { disabled: disableClick, style: UNSELECTABLE_STYLE, attribute: UNSELECTABLE_ATTRIBUTE, value: column, key: getColumnKey(column, i) }, title));
            }
        });
        return options;
    }
    getVisibleColumns() {
        const { columns } = this.props;
        return (columns || []).filter(column => !column.hidden);
    }
}
ColumnFilter.displayName = 'ColumnFilter';
